export const FAQS = [
  {
    q: "Do you perform mold remediation?",
    a: "No — and that's the point. Hurtler Environmental is strictly independent. We assess, write protocols, and perform post-remediation verification. We never remediate, accept commissions from contractors, or own equity in restoration firms.",
  },
  {
    q: "How long does a typical residential mold assessment take?",
    a: "Most single-family assessments take 1.5–3 hours on-site. A written report with lab results, interpretation, and (when warranted) a protocol typically follows within 5–7 business days.",
  },
  {
    q: "What is the difference between Category 1, 2, and 3 water?",
    a: "Per IICRC S500, Category 1 is clean (supply line), Category 2 is significantly contaminated (washing machine overflow), and Category 3 is grossly contaminated and may contain pathogens (sewage, rising flood water). Categorization drives the entire remediation scope.",
  },
  {
    q: "Why does indoor mold sampling need outdoor controls?",
    a: "Indoor air shares mold spores with outdoor air through normal ventilation. Without a simultaneous outdoor control collected under similar conditions, an indoor sample is uninterpretable in isolation.",
  },
  {
    q: "What standards do your reports follow?",
    a: "Primarily IICRC S520 (mold), IICRC S500 (water damage), ANSI/IICRC S540 (trauma/biohazard/sewage), ASHRAE 62.1/62.2 (ventilation), ACGIH Bioaerosols, and applicable EPA guidance.",
  },
  {
    q: "Do you work directly with insurance carriers and attorneys?",
    a: "Yes. We routinely provide independent third-party scoping, categorization disputes, expert opinions, and litigation support. Our deliverables are designed to withstand cross-examination.",
  },
  {
    q: "Can you assess a property before purchase?",
    a: "Yes — pre-purchase environmental assessments are one of our most-requested residential services, often during option periods. Realtors and buyers alike use us for an independent science-based second opinion.",
  },
  {
    q: "What service areas do you cover in Texas?",
    a: "We are headquartered in Edinburg, TX and serve the Rio Grande Valley, South Texas, and Coastal Bend regions as our core service area, with project work across the state.",
  },
];
